/**
 * Created by bszggg on 2019. 06. 15..
 */
import moment from 'moment';
import SettingsContainer from '@/helper/SettingsContainer';
import hash from "object-hash";
import Helper from "./Helper";

/**
 * Helper General functions for all of product parts
 */
const HelperRole = {


  healthCheckHandler: function (modul, res) {
    /*
     user
     companymoduleIds
     userrolesforcompanyIds
     * */
    if (res && res.data && res.result === true && res.validtoken === true ) {
      const state = HelperRole.makeStateFromData(res.data);
      const copiedState = Object.assign({}, modul.$store.state);
      const newState = Object.assign(copiedState, state);
      modul.$store.replaceState(newState);

    } else {
      if (modul.$router.currentRoute && modul.$router.currentRoute.name !== null && modul.$router.currentRoute.name !== "login" && modul.$router.currentRoute.name !== "register" && modul.$router.currentRoute.name !== "remember" && modul.$router.currentRoute.name !== "pset") { // routename
        if(res && res.validtoken === false){
          const alertId = Math.random();
          modul.$eventBus.$emit('globalAlert', {
            id: alertId,
            type: "danger",
            msgPreInner: "",
            msg: "form.token_error",
            msgPostInner: "",
            delay: 5000
          });
        }
        console.log("redirect login from HelperRole")
        console.log(modul.$router.currentRoute)
        console.log(modul.$router.currentRoute.name)
        modul.$router.push({name: "login"})
      }
    }
  },
  healthCheckClear: function (state) {
    state.id_company = "0";
    state.userhash = "";
    state.settingshash = "";
    state.userhash = "";
    state.user = {};
    state.settings = {};
    state.settingshash = "";
    state.frontendVersion = "";
    state.healthCheckHash = "";
    // state.userrolesforcompanyIds = [];
    // state.userrolesforcompany = [];
    // state.userrolesforcompanyhash = "";
    // state.healthCheckHash = "";
    // state.user = {};
    // state.userhash = "";
    // state.companymoduleIds = [];
    // state.companymodules = [];
    // state.companymoduleshash = "";
    // state.usercompanies = [];
    // state.usercompanieshash = "";
  },
  makeStateFromData: function (data) {
    const state = {};
    state.id_company = "0";
    state.userhash = "";
    state.settingshash = "";

    if (data && data.user) {
      /*id "1"
       id_company	"1"
       user_name	"admin"
       user_role	"8"
       real_name	"admina"
       companyname	"Teszt eladó kft (fejlesztői teszt)"*/

      state.id_company = (data.user && data.user.id_company) ? (data.user.id_company) : null;
      const user = Object.assign({}, data.user);
      delete(user.id_company_actual);
      state.user = user; //data.user;
      state.userhash = hash(user); // data.user
      state.user.name = data.user.real_name;
    }
    // if (data.companymodules) {
    //   const companymoduleIds = [];
    //   if (Array.isArray(data.companymodules)) {
    //     Array.prototype.forEach.call(data.companymodules, function (e) {
    //       companymoduleIds.push(e.id2);
    //     })
    //   }
    //   state.companymoduleIds = companymoduleIds;
    //   state.companymodules = data.companymodules;
    //   state.companymoduleshash = hash(data.companymodules);
    // }
    // if (data.usercompanies) {
    //   state.usercompanies = data.usercompanies;
    //   state.usercompanieshash = hash(data.usercompanies);
    // }
    // if (data.userrolesforcompany) {
    //   const userrolesforcompanyIds = [];
    //   if (Array.isArray(data.userrolesforcompany)) {
    //     Array.prototype.forEach.call(data.userrolesforcompany, function (e) {
    //       userrolesforcompanyIds.push(e.id2);
    //     })
    //   }
    //   state.userrolesforcompanyIds = userrolesforcompanyIds;
    //   state.userrolesforcompany = data.userrolesforcompany;
    //   state.userrolesforcompanyhash = hash(data.userrolesforcompany);
    // }
    if (data.settings) {
      state.settings = data.settings;
      state.settingshash = hash(data.settings);
    }
    if (data.frontendVersion) {
      state.frontendVersion = data.frontendVersion;
    }
    state.healthCheckHash = hash(Helper.String(state.settingshash) + Helper.String(state.id_company) + Helper.String(state.userhash));

    return state;
  },
  _hasMyCompany: function (state) {
    let user = state.user;
    let usercompanies = state.usercompanies;

    let isMyCompany = false;
    if (Array.isArray(usercompanies)) {
      Array.prototype.forEach.call(usercompanies, function (e) {
        if (e.company_id_owner === user.id) {
          isMyCompany = true;
        }
      })
    }
    return isMyCompany;
  },

  /**
   *
   * Általános role vizsgáló a modul features-eihez
   *
   * @param state -- state with actual datas
   * @param moduleIds -- modul ids which is content this feature
   * @param userrolesforcompanyIds
   * @param skipUserRoleCheck -- Ez ha true, akkor az admin jogokat nem nézi, és lehet vele külön csak moduljogot lekérdezni
   * @returns {boolean}

   levizsgáljuk, hogy
   van-e cég kiválasztva (state alapján)
   -IGEN:
   --ha van, annak a cégnek van-e joga a modulid-kben felsoroltakból valamelyikhez
   ---IGEN:

   ---Ha admin, akkor a saját cége e
   -----IGEN: TRUE
   -----NEM:
   ------Ha van, annak az usernek az userrole-sben felsoroltak közül egy is (company-ra vonatkoztatva), akkor ha
   -------IGEN: TRUE
   -------NEM: FALSE

   ---NEM: FALSE
   -NEM: FALSE

   Params: Aktuális adat -- Milyen modulokkal rendelkező cégnek, --  milyen userrolessal ellátott használójának van, -- Milyen userlevellel    :   joga
   */
  hasRights: function (state, moduleIds, userrolesforcompanyIds, skipUserRoleCheck) {

    let arrUserrolesforcompanyIds = Array.from(userrolesforcompanyIds);
    let stateCompanymoduleIds = state.companymoduleIds;
    let stateuserrolesforcompanyIds = state.userrolesforcompanyIds;
    let id_company = state.id_company;
    let user = state.user;
    let uerRoleCheck = (!skipUserRoleCheck);

    let ret = false;
    // van-e cég kiválasztva (state alapján)
    if (id_company) {
      // ha van, annak a cégnek van-e joga a modulid-kben felsoroltakból valamelyikhez

      let hasmoduleid = false;
      if (moduleIds === true) { // -> skip this check
        hasmoduleid = true;
      } else if (moduleIds === false) { // -> false .. deny
        hasmoduleid = false;
      } else if (Array.isArray(moduleIds)) { // do the checks and continue
        if (Array.isArray(stateCompanymoduleIds)) {
          Array.prototype.forEach.call(stateCompanymoduleIds, function (e) {
            if (moduleIds.includes(e)) {
              hasmoduleid = true;
            }
          })
        }
      }

      if (hasmoduleid) {
        //Ha admin, akkor a saját cége e
        if (uerRoleCheck && user.role === "ADMIN" && HelperRole._hasMyCompany(state)) {
          ret = true
        } else {
          // Ha van, annak az usernek az userrole-sben felsoroltak közül egy is (company-ra vonatkoztatva), akkor ha
          let hasuserrole = false;

          if (userrolesforcompanyIds === true) { // -> skip this check, true -> access
            hasuserrole = true;
          } else if (userrolesforcompanyIds === false) { // -> false .. deny
            hasuserrole = false;
          } else if (Array.isArray(stateuserrolesforcompanyIds)) {
            Array.prototype.forEach.call(stateuserrolesforcompanyIds, function (e) {
              if (arrUserrolesforcompanyIds.includes(e)) {
                hasuserrole = true;
              }
            })
          }
          if (hasuserrole) {
            ret = true
          } else {
            ret = false;
          }
        }
      } else {
        ret = false;
      }
    } else {
      ret = false;
    }
    return ret;
  },


};

export default HelperRole;
